<header class="calendar-header">
  <h3 class="calendar-header-title"><%= moment(calendarDate).format('MMMM YYYY') %></h3>
  <div class="calendar-header-button-group">
    <% if (canShowPreviousMonth) { %>
    <span class="calendar-header-button calendar-last-month" data-appointment-booking-slot-picker-modal-behaviour="show-previous-month"
          data-analytics-element="slot-picker-calendar-month" data-analytics-interaction="click" data-analytics-value="previous">
      <svg class='calendar-icon' xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 320" enable-background="new 0 0 320 320"><path d="M220 154.7h-105.4l51.4-51.1c2.4-2.3 2.4-6.1 0-8.5-2.3-2.4-6.1-2.4-8.5 0l-61.7 61.4c-1.1 1.1-1.8 2.6-1.8 4.3 0 1.7.7 3.2 1.8 4.3l63.2 62.8c1.2 1.2 2.7 1.7 4.2 1.7s3.1-.6 4.3-1.8c2.3-2.4 2.3-6.1 0-8.5l-52.9-52.5h105.4c3.3 0 6-2.7 6-6 0-3.4-2.7-6.1-6-6.1z"/></svg>
    </span>
    <% } %>
    <span class="calendar-header-button calendar-next-month" data-appointment-booking-slot-picker-modal-behaviour="show-next-month"
          data-analytics-element="slot-picker-calendar-month" data-analytics-interaction="click" data-analytics-value="next">
      <svg class='calendar-icon' xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 320" enable-background="new 0 0 320 320"><path d="M223 154.7l-63.1-62.7c-2.4-2.3-6.1-2.3-8.5 0-2.3 2.4-2.3 6.1 0 8.5l52.9 52.5h-105.5c-3.3 0-6 2.7-6 6s2.7 6 6 6h105.5l-51.4 51.1c-2.4 2.3-2.4 6.1 0 8.5 1.2 1.2 2.7 1.8 4.3 1.8 1.5 0 3.1-.6 4.2-1.7l61.8-61.4c.3-.3.5-.6.7-.9.6-.9 1-2.1 1-3.3v-.1c-.1-1.7-.8-3.2-1.9-4.3z"/></svg>
    </span>
  </div>
</header>
<% if (_.size(appointmentGridDates) > 0) { %>
  <%
    // The record the calendar's interactions are attributed to, resolved the same way the header does it.
    var analyticsRecord = filters.get('resource_type') && filters.get('resource_id') ? [filters.get('resource_type'), filters.get('resource_id')]
      : filters.get('physician_id') ? ['Physician', filters.get('physician_id')]
      : resource.get('type') && resource.get('id') ? [resource.get('type'), resource.get('id')] : null;
  %>
  <div class="calendar-table" <%= analyticsRecord ? `data-resource-type="${analyticsRecord[0]}" data-resource-id="${analyticsRecord[1]}"` : '' %>></div>
<% } else { %>
  <div class="appointments-list-empty">
    <div class="appointments-list-empty__header">
      <div class="appointments-list-empty__message"><%= I18n.messages.no_results %></div>
    </div>
  </div>
  <%= JST['appointment_booking/slot_picker_modal/templates/fallback_message']({schedulingOptions: schedulingOptions}) %>
<% } %>
